export default {"src":"/_next/static/media/blockedDeposit.4ef55d73.svg","height":28,"width":28};